export const IsUrlRegex = new RegExp(/(^https?:\/\/[^\s]+)/, "i");
